export var props = {
  title: {
    type: [Number, String]
  },
  icon: {
    type: String
  },
  desc: {
    type: String
  },
  border: {
    type: Boolean,
    default: false
  },
  iconClass: {
    type: String
  },
  titleClass: {
    type: String
  },
  descClass: {
    type: String
  },
  extraClass: {
    type: String
  }
};